module.exports = __webpack_public_path__ + "static/images/m-rig-matrixradio@2x.0291749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/m-rig-matrixradio@2x.png
// module id = 9krb
// module chunks = 6 7